var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import User from '../model/User';
import axios from 'axios';
var ReLoginStore = /** @class */ (function () {
    function ReLoginStore() {
        this.timerId = 0;
        this.timerObj = {}; //控制轮训的标识位
        this.unitTime = 1000; //单位秒
        this.intervalTime = 10 * this.unitTime; //轮训时间间隔  
        this.delayTime = 30 * this.unitTime; //轮训时间间隔
    }
    /**
     * 设置轮训时间间隔
     * @param {*} intervalTime 秒
     */
    ReLoginStore.prototype.setIntervalTime = function (intervalTime) {
        this.intervalTime = intervalTime * this.unitTime;
        return this;
    };
    /**
     * 设置延迟启动时间
     * @param {*} delayTime
     */
    ReLoginStore.prototype.setDelayTime = function (delayTime) {
        this.delayTime = delayTime * this.unitTime;
        return this;
    };
    /**
     * 重登陆方法
     */
    ReLoginStore.relogin = function () {
        return __awaiter(this, void 0, void 0, function () {
            var user, param;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        user = Object.assign(new User(), User.restore());
                        param = {
                            clientName: window.localStorage.clientName,
                            desc: window.localStorage.desc
                        };
                        return [4 /*yield*/, user.loginTplus(param)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 延长session时长  重连接口
     */
    ReLoginStore.reconnect = function () {
        return __awaiter(this, void 0, void 0, function () {
            var user;
            return __generator(this, function (_a) {
                user = User.restore();
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        axios.create({ baseURL: user.channel.targetURL }).get("/sm/runmanage/linktplus.aspx?method=getonlinusers&token=" + user.tplusToken).then(function (res) {
                            if (res.status === 200) {
                                resolve(true);
                            }
                            else {
                                resolve(false);
                            }
                        });
                    })];
            });
        });
    };
    /**
     * 判断当前环境是否是云部署
     */
    ReLoginStore.prototype.isCloudProxy = function () {
        return __awaiter(this, void 0, void 0, function () {
            var user;
            return __generator(this, function (_a) {
                user = User.restore();
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        axios.create({ baseURL: user.channel.targetURL }).get('/ajaxpro/Ufida.T.SM.Login.UIP.LoginManager,Ufida.T.SM.Login.UIP.ashx?method=GetVersionType').then(function (res) {
                            if (res.status === 200 && res.data.value && res.data.value.IsCloudDeployment) {
                                resolve(res.data.value.IsCloudDeployment);
                            }
                            else {
                                resolve(false);
                            }
                        });
                    })];
            });
        });
    };
    /**
     * 开启重登陆轮询
     */
    ReLoginStore.prototype.start = function () {
        return __awaiter(this, void 0, void 0, function () {
            function timerFn() {
                return __awaiter(this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!timerObj[id]) {
                                    return [2 /*return*/];
                                }
                                return [4 /*yield*/, ReLoginStore.reconnect()];
                            case 1:
                                _a.sent();
                                setTimeout(timerFn, intervalTime);
                                return [2 /*return*/];
                        }
                    });
                });
            }
            var id, timerObj, intervalTime;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.delay()];
                    case 1:
                        _a.sent();
                        id = this.timerId++;
                        this.timerObj[id] = true;
                        timerObj = this.timerObj;
                        intervalTime = this.intervalTime;
                        timerFn();
                        return [2 /*return*/];
                }
            });
        });
    };
    ReLoginStore.prototype.delay = function () {
        return __awaiter(this, void 0, void 0, function () {
            var delayTime;
            return __generator(this, function (_a) {
                delayTime = this.delayTime;
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        setTimeout(function () {
                            resolve();
                        }, delayTime);
                    })];
            });
        });
    };
    /**
     * 关闭轮询
     */
    ReLoginStore.prototype.stop = function () {
        this.timerObj = {};
    };
    return ReLoginStore;
}());
export default ReLoginStore;

//# sourceMappingURL=ReLoginStore.js.map
